import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { 
  Button, 
  Card, 
  CardActions, 
  CardContent, 
  Container, 
  FormControl, 
  Grid, 
  InputLabel, 
  MenuItem, 
  Select, 
  Typography 
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ESTADISTICAS_OSPEDYC } from "../../../utils/constants";
import LoadingBeforeViewData from "../../compartidos/LoadingBeforeViewData";
import { cargarEstadisticas } from "../../../actions/miOspedyc/estadisticasMiOspedyc";
import { ESTADO_SOLICITUD_INTEGRACION, TIPO_SOLICITUD_INTEGRACION } from "../../Discapacidad/data/constants";
import { getSolicitudesDiscapacidadAutoG, setSolicitudDiscapacidadAutoG } from "../../../actions/webAfiliado/afiliadoDiscapacidadActions";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    marginTop: "1.5rem",
    marginBottom: "1rem"
  },
  title: {
    fontWeight: "bold",
    marginBottom: "1rem"
  },
  containerCard: {
    paddingRight: "1rem",
    paddingLeft: "1rem"
  },
  cardIn: {
    borderTopColor: theme.palette.primary.main,
    borderTopStyle: "outset",
    borderTopWidth: "thick",
    marginRight: "1rem",
    marginLeft: "1rem",
    marginBottom: "1rem",
    borderRadius: 10,
  },
  titleCard: {
    fontWeight: "bold",
    fontSize: 14,
    marginTop: "0.75rem"
  },
  formControl: {
    marginBottom: 5,
    marginLeft: "1rem",
    marginRight: "1rem",
    paddingRight: "2rem",
  }
}));

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const MisSolicitudes = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch()

  const { idAfiliado } = useSelector(state => state.auth)
  const { solicitudes, loading } = useSelector(state => state.afiliadoDiscapacidad)

  const [idEstado, setIdEstado] = React.useState(ESTADO_SOLICITUD_INTEGRACION.EN_CARGA_AFILIADO);
  const [redirect, setRedirect] = React.useState(false);

  useEffect(() => {
    dispatch(cargarEstadisticas(ESTADISTICAS_OSPEDYC.DISCAPACIDAD))
  }, [dispatch])

  useEffect(() => {
    if (idAfiliado) {
      dispatch(getSolicitudesDiscapacidadAutoG(idAfiliado, idEstado))
    }
  }, [dispatch, idAfiliado, idEstado])

  if (loading) {
    return <LoadingBeforeViewData />
  }

  const postIrASolicitud = (item) => {
    dispatch(setSolicitudDiscapacidadAutoG(item));
    setRedirect(true);
  }

  return (
    <div className={classes.root}>
      <Container maxWidth="md">
        <Typography align="center" variant="h4" color="primary" className={classes.title}>Mis Solicitudes</Typography>
        <Grid container className={classes.container}>
          <Grid item xs={12}>
            <Grid container style={{ marginTop: "1rem" }}>
              <Grid item xs={12} className={classes.containerCard}>
                <FormControl className={classes.formControl} fullWidth>
                  <InputLabel id="estadoSelectLabel">Estado Solicitud</InputLabel>
                  <Select
                    labelId="estadoSelectLabel"
                    id="estadoSelectLabel"
                    value={idEstado}
                    name="idEstado"                        
                    onChange={(e) => setIdEstado(e.target.value)}
                  >
                    {Object.entries(ESTADO_SOLICITUD_INTEGRACION).map((item) => (
                      <MenuItem key={item[1]} value={item[1]}>
                        {item[0].charAt(0) + item[0].replaceAll("_", " ").toLowerCase().slice(1)}
                      </MenuItem>
                    ))}                            
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            {
              solicitudes.length === 0
                ?
                  <>
                    <Typography align="center">No contás con solicitudes en el Estado Seleccionado.</Typography>
                    {idEstado === ESTADO_SOLICITUD_INTEGRACION.EN_CARGA_AFILIADO &&
                      <Typography align="center"> Para cargar una Solicitud, haz clic <Link to="/afiliado/discapacidad/nueva-solicitud">aquí</Link></Typography>
                    }
                  </>
                :
                  <Grid container style={{ marginTop: "1rem" }}>
                    {
                      solicitudes.map(item => {
                        return (
                          <React.Fragment key={item.idSolicitud}>
                            {
                              solicitudes.length === 1 &&
                              <Grid item xs={null} md={3} />
                            }
                            <Grid item xs={12} md={6} className={classes.containerCard}>
                              <Card variant="outlined" className={classes.cardIn}>
                                <CardContent style={{ textAlign: "center" }}>
                                  <Typography color="primary" className={classes.titleCard}>
                                    Número Solicitud: <span style={{color: 'black', fontWeight: 'normal'}}>{item.idSolicitud}</span>
                                  </Typography>

                                  {/* <Typography color="primary" className={classes.titleCard}>Nombre completo</Typography>
                                  <Typography>{item.afiliado.apellido_y_nombre}</Typography> */}

                                  <Typography color="primary" className={classes.titleCard}>Tipo Solicitud</Typography>
                                  <Typography>{item.tipoSolicitudIntegracion.descripcion}</Typography>

                                  {item.tipoSolicitudIntegracion.idTipo !== TIPO_SOLICITUD_INTEGRACION.HOGAR &&
                                      <>
                                        <Typography color="primary" className={classes.titleCard}>SubTipo Solicitud</Typography>
                                        <Typography>{item.subTipoSolicitudIntegracion?.descripcion}</Typography>
                                      </>
                                  }

                                  <Typography color="primary" className={classes.titleCard}>Prestador</Typography>
                                  <Typography>{item.efectorFacturacion.nombreFantasia}</Typography>

                                  {/* <Typography color="primary" className={classes.titleCard}>Diagnostico</Typography>
                                  <Typography style={{color: !item.diagnostico&& 'red'}}>
                                    {item.diagnostico ? item.diagnostico?.descripcion : 'No Cargado'}
                                  </Typography> */}

                                  <Typography color="primary" className={classes.titleCard}>Fecha Desde</Typography>
                                  <Typography>{new Date(item.fechaDesde).toLocaleString("es", optionsfecha)}</Typography>

                                  <Typography color="primary" className={classes.titleCard}>Fecha Hasta</Typography>
                                  <Typography>{new Date(item.fechaHasta).toLocaleString("es", optionsfecha)}</Typography>

                                </CardContent>
                                {item.idEstadoSolicitud === ESTADO_SOLICITUD_INTEGRACION.EN_CARGA_AFILIADO&&
                                  <CardActions style={{ justifyContent: "center" }}>
                                    <Button 
                                      size="small" 
                                      color="primary" 
                                      variant="contained" 
                                      onClick={() => {
                                        postIrASolicitud(item);
                                      }}
                                    >
                                      Continuar Carga
                                    </Button>
                                  </CardActions>
                                }
                              </Card>
                            </Grid>
                            {
                              solicitudes.length === 1 &&
                              <Grid item xs={null} md={3} />
                            }
                          </React.Fragment>
                        )
                      })
                    }
                  </Grid>
            }
          </Grid>
        </Grid>
        {redirect && (
          <Redirect
            to={{
              pathname: '/afiliado/discapacidad/nueva-solicitud',
              state: {
                from: '/afiliado/discapacidad/mis-solicitudes'
              },
            }}
          />
        )}
      </Container>
    </div>
  );
};
